import { gql } from "@apollo/client";

export const FINISH_TIME_TICKETS_MUTATION = gql`
    mutation finishCrewMemberAssignments($assignments: [FinishCrewMemberAssignmentInputType]!) {
        finishCrewMemberAssignments(assignments: $assignments) {
            newAssignments {
                id
                startTime
                endTime
            }
        }
    }
`

export const UPDATE_APPROVAL_FOR_CREW_MEMBER_ASSIGNMENTS_MUTATION = gql`
    mutation updateApprovalForCrewMemberAssignments($assignments: [UpdateAssignmentApprovalInputType]!) {
        updateApprovalForCrewMemberAssignments(assignments: $assignments) {
            updatedAssignments {
                id
            }
        }
    }
`

export const MARK_CREW_MEMBER_ASSIGNMENTS_AS_PAID_MUTATION = gql`
    mutation markCrewMemberAssignmentsAsPaid($assignments: [Int]!, $paidDate: Date!) {
        markCrewMemberAssignmentsAsPaid(assignments: $assignments, paidDate: $paidDate) {
            updatedAssignments {
                id
            }
        }
    }
`